const attrToBoolean = (value) => value !== undefined && value !== null && value !== false && value !== 'false' && value !== '0';

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent);
}

function isTouchScreen() {
    return ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
}

const snakeToCamel = (str) => str.replace(/([-_][a-z])/g, (group) => group.toUpperCase()
    .replace('-', '')
    .replace('_', ''));
function instanceOfTest(object) {
    return 'selectorDowngrade' in object;
}

function getUniqueID() {
    return Math.random()
        .toString(36)
        .substr(2, 9);
}

class Translations {
    static getTexts() {
        return {
            pair_a_device: {
                en: `TytoCare`,
                es: `TytoCare`,
                he: `TytoCare`
            },
            yes: {
                en: `Yes`,
                es: `Si`,
                he: `כן`
            },
            no: {
                en: `No`,
                es: `No`,
                he: `לא`
            },
            connect_to_a_network: {
                en: `Connect this app to your Tyto Device via WiFi `,
                es: `Cómo emparejar su dispositivo Tyto`,
                he: `כיצד להתאים את מכשיר ה- Tyto שלך`
            },
            password: {
                en: `Password`,
                es: `Contraseña`,
                he: `סיסמה`
            },
            wifi_network: {
                en: `WiFi Network`,
                es: `Red Wi Fi`,
                he: `רשת WiFi`
            },
            previous_step: {
                en: `Previous`,
                es: `Próximo paso`,
                he: `קודם`
            },
            need_help: {
                en: `Need Help?`,
                es: `¿Necesitas ayuda?`,
                he: `זקוק לעזרה?`
            },
            next: {
                en: `Next`,
                es: `Próxima`,
                he: `הַבָּא`
            },
            previous: {
                en: `Previous`,
                es: `Previa`,
                he: `קודם`
            },
            next_slide: {
                en: `Next slide`,
                es: `La siguiente diapositiva`,
                he: `השקופית הבאה`
            },
            previous_slide: {
                en: `Previous slide`,
                es: `Diapositiva anterior`,
                he: `שקופית קודמת`
            },
            cancel_setup: {
                en: `Cancel Setup`,
                es: `Cancelar configuración`,
                he: `בטל את ההתקנה`
            },
            generate_new_code: {
                en: `Generate New Code`,
                es: `Generar código nuevo`,
                he: `צור קוד חדש`
            },
            try_again: {
                en: `Pair Again`,
                es: `Emparejar de nuevo`,
                he: `זוג שוב`
            },
            continue: {
                en: `Continue`,
                es: `Seguir`,
                he: `לְהַמשִׁיך`
            },
            loading: {
                en: `Loading ...`,
                es: `Loading ...`,
                he: `טעינה`
            },
            send_message: {
                en: `Send Message`,
                es: `Enviar mensaje`,
                he: `לשלוח הודעה`
            },
            attach_files: {
                en: `Attach files`,
                es: `Adjuntar archivos`,
                he: `צרף קבצים`
            },
            tyto_greeting: {
                en: `TytoCare is a handheld exam kit that lets you perform guided medical exams with a healthcare provider.`,
                es: `TytoCare es un kit de examen portátil que le permite realizar exámenes médicos guiados con un proveedor de atención médica.`,
                he: `TytoCare היא ערכת בחינות כף יד המאפשרת לך לבצע בדיקות רפואיות מודרכות אצל ספק שירותי בריאות.`
            },
            tyto_slider: {
                en: `How to Pair Your Tyto Device`,
                es: `Cómo emparejar su dispositivo Tyto`,
                he: `כיצד להתאים את מכשיר ה- Tyto שלך`
            },
            tyto_question_for_using: {
                en: `Will you be using a Tyto Device during this visit?`,
                es: `¿Utilizará un dispositivo Tyto durante esta visita?`,
                he: `האם תשתמש במכשיר Tyto במהלך ביקור זה?`
            },
            tyto_help_text: {
                en: `Enter the credentials for your home WiFi network. A barcode will be generated to set up your Tyto Device.`,
                es: `Ingrese las credenciales de su red WiFi doméstica. Se generará un código de barras para configurar su dispositivo Tyto.`,
                he: `הזן את האישורים עבור רשת ה- WiFi הביתית שלך. ייווצר ברקוד להגדרת מכשיר ה- Tyto שלך.s`
            },
            tyto_pro_help_text: {
                en: `Enter the credentials for WiFi network. A barcode will be generated to set up your Tyto Device.`,
                es: `Ingrese las credenciales de la red WiFi. Se genera un código de barras para configurar su dispositivo Tyto.`,
                he: `הזן את אישורי רשת ה- WiFi. ייווצר ברקוד להגדרת מכשיר ה- Tyto שלך.`
            },
            scan_qr_code_below: {
                en: `Scan the barcode with your Tyto Device `,
                es: `Escanee el código de barras con su dispositivo Tyto`,
                he: `סרוק את הברקוד עם מכשיר Tyto שלך`
            },
            tyto_scan_qr1: {
                en: `Point the camera of your Tyto Device at this code and then follow the instructions on the screen to start setup.`,
                es: `Apunte la cámara de su dispositivo Tyto a este código y luego siga las instrucciones en la pantalla para iniciar la configuración.`,
                he: `כוון את המצלמה של מכשיר ה- Tyto שלך לקוד זה ואז עקוב אחר ההוראות שעל המסך כדי להתחיל בהתקנה.`
            },
            tyto_scan_qr2: {
                en: `Once successfully paired, you will be be prompted to join an online visit.`,
                es: `Una vez emparejado correctamente, se le pedirá que se una a una visita en línea.`,
                he: `לאחר ההתאמה בהצלחה, תתבקש להצטרף לביקור מקוון.`
            },
            tyto_qr_error: {
                en: `QR Code Error`,
                es: `Error de código QR`,
                he: `שגיאת קוד QR`
            },
            tyto_qr_generate: {
                en: `Please generate a new code and scan using your Tyto Device.`,
                es: `Genere un nuevo código y escanee con su dispositivo Tyto.`,
                he: `אנא צור קוד חדש וסרוק באמצעות מכשיר ה- Tyto שלך.`
            },
            pairing_complete: {
                en: `Pairing Complete`,
                es: `Emparejamiento completa`,
                he: `ההתאמה הושלמה`
            },
            tyto_success: {
                en: `Your Tyto Device has been successfully paired to use during your visit.`,
                es: `Su dispositivo Tyto se ha emparejado correctamente para utilizarlo durante su visita.`,
                he: `מכשיר ה- Tyto שלך הותאם בהצלחה לשימוש במהלך ביקורך.`
            },
            change_network: {
                en: `Change Network`,
                es: `Cambiar red`,
                he: `שנה רשת`
            },
            pairing_failed: {
                en: `Something went wrong`,
                es: `Algo salió mal`,
                he: `משהו השתבש`
            },
            tyto_fail: {
                en: `We’re having trouble connecting to TytoCare. Please try to pair again.`,
                es: `Tenemos problemas para conectarnos a TytoCare. Intente emparejar de nuevo.`,
                he: `אנו מתקשים להתחבר ל- TytoCare. נסה להתאים שוב.`
            },
            start_setup: {
                en: `Start Setup`,
                es: `Iniciar configuración`,
                he: `התחל בהתקנה`
            },
            connect_wifi: {
                en: `Connect to WiFi`,
                es: `Conectarse a WiFi`,
                he: `התחבר ל- WiFi`
            },
            connect_your_device: {
                en: `Connect your Tyto Device to your home WiFi network to begin pairing.`,
                es: `Conecte su dispositivo Tyto a la red WiFi de su hogar para comenzar a emparejar.`,
                he: `חבר את מכשיר ה- Tyto שלך לרשת ה- WiFi הביתית שלך כדי להתחיל בהתאמה.`
            },
            connect_your_pro_device: {
                en: `Connect your Tyto Device to WiFi network to begin pairing.`,
                es: `Conecte su dispositivo Tyto a la red WiFi para comenzar a emparejar.`,
                he: `חבר את ה- Tyto שלך לרשת WiFi כדי להתחיל`
            },
            pairing_complete_screen2: {
                en: `Your Tyto Device is ready for your exam`,
                es: `Su dispositivo Tyto está listo para su examen`,
                he: `מכשיר ה- Tyto שלך מוכן לבחינה שלך`
            },
            tyto_success_screen2: {
                en: `To conduct an exam, select Join Online Visit then follow the directions on your Tyto Device.`,
                es: `Para realizar un examen, seleccione Unirse a la visita en línea y luego siga las instrucciones en su dispositivo Tyto.`,
                he: `כדי לערוך בחינה, בחר הצטרף לביקור מקוון ואז עקוב אחר ההוראות במכשיר Tyto שלך.`
            },
            having_trouble: {
                en: `Having trouble with WiFi?`,
                es: `¿Teniendo problemas con el WiFi?`,
                he: `נתקל בבעיות עם WiFi?`
            },
            pairing_complete_screen3: {
                en: `Exam underway...`,
                es: `Examen en curso...`,
                he: `הבחינה בעיצומה...`
            },
            tyto_success_screen3: {
                en: `TytoCare device is under remote control of your clinician.`,
                es: `El dispositivo TytoCare está bajo el control remoto de su médico.`,
                he: `מכשיר TytoCare נמצא בשליטה מרחוק של הקלינאי שלך.`
            },
            datepicker_aria_field_description: {
                en: `You’re on a date field. {selectedDate}. Either type in the date you want in the format: {format} or click the "open calendar" button to select a date.`,
                es: `Está en un campo de fecha. {selectedDate}. Escribe la fecha que desea en el formato: {format} o haga clic en el botón "abrir calendario" para seleccionar una fecha.`,
                he: `אתה בשדה של תאריך. {selectedDate}. הקלד את התאריך שאתה רוצה בתבנית: {format} או לחץ על הכפתור "פתח לוח שנה" כדי לבחור תאריך.`
            },
            datepicker_selected_date: {
                en: `Currently selected`,
                es: `Fecha seleccionada`,
                he: `תאריך שנבחר`
            },
            datepicker_selected_start_date: {
                en: ` Currently selected as Start Date`,
                es: `Seleccionado como fecha de inicio`,
                he: `נבחר כעת כתאריך התחלה`
            },
            datepicker_selected_end_date: {
                en: ` Currently selected as End Date`,
                es: `Seleccionado como fecha de final`,
                he: `נבחר כעת כתאריך סיום`
            },
            datepicker_aria_dialog_description: {
                en: `Use the arrow keys to navigate between days and weeks. Press enter to select the date, and escape to close the calendar and return to the date input field.`,
                es: `Utilice las teclas de dirección para navegar entre días y semanas. Presione enter para seleccionar la fecha, y escape para cerrar el calendario y volver al campo de entrada de fecha.`,
                he: `השתמש בחצים למעלה ולמטה כדי לנווט בין ימים ובין שבועות. לחץ Enter כדי לבחור תאריך, וEscape כדי לסגור את הלוח ולחזור לשדה התאריך.`
            },
            datepicker_selecte_today: {
                en: `Select today's date`,
                es: `Seleccionar la fecha de hoy`,
                he: `בחר את תאריך היום`
            },
            datepicker_select_year: {
                en: `Switch to the year selection`,
                es: `Cambiar a la selección de año`,
                he: `החלף לבחירת שנה`
            },
            datepicker_select_month: {
                en: `Switch to the month selection`,
                es: `Cambiar a la selección de mes`,
                he: `עבור לבחירת החודש`
            },
            datepicker_incorrect_format: {
                en: `The value of the field has incorrect format. Format is "{1}"`,
                es: `El valor del campo tiene formato incorrecto. El formato es "{1}"`,
                he: `הערך של השדה אינו בתבנית הנכונה. התבנית היא "{1}"`
            },
            datepicker_incorrect_format_range: {
                en: `The value of the field has incorrect format. Format is "{1} - {2}"`,
                es: `El valor del campo tiene formato incorrecto. El formato es "{1} - {2}"`,
                he: `הערך של השדה אינו בתבנית הנכונה. התבנית היא "{1} - {2}"`
            },
            filters: {
                en: `Filters`,
                es: `Filtros`,
                he: `מסננים`
            },
            manage: {
                en: `Manage`,
                es: `Gestionar`,
                he: `לנהל`
            },
            applied_filters: {
                en: `applied filters`,
                es: `filtros aplicados`,
                he: `מסננים שהוחלו`
            },
            clear_all: {
                en: `Clear All`,
                es: `Limpiar todo`,
                he: `נקה הכל`
            },
            apply: {
                en: `Apply`,
                es: `Solicitar`,
                he: `להגיש מועמדות`
            },
            items_available_use_search: {
                en: `items are available. Use search`,
                es: `los artículos están disponibles. Usar búsqueda`,
                he: `פריטים זמינים. השתמש בחיפוש`
            },
            items_contain: {
                en: `items contain`,
                es: `los elementos contienen`,
                he: `פריטים מכילים`
            },
            search: {
                en: `Search`,
                es: `Búsqueda`,
                he: `לחפש`
            },
            done: {
                en: `Done`,
                es: `Hecho`,
                he: `בוצע`
            },
            customize: {
                en: `Customize`,
                es: `Personalizar`,
                he: `להתאים אישית`
            },
            sort_by: {
                en: `Sort data by`,
                es: `Ordenar datos por`,
                he: `מיין נתונים לפי`
            },
            columns: {
                en: `Columns`,
                es: `Columnas`,
                he: `עמודות`
            }
        };
    }
}

function toOrdinalNumber(i) {
    const j = i % 10;
    const k = i % 100;
    if (j === 1 && k !== 11) {
        return `${i}st`;
    }
    if (j === 2 && k !== 12) {
        return `${i}nd`;
    }
    if (j === 3 && k !== 13) {
        return `${i}rd`;
    }
    return `${i}th`;
}

const hasObservers = (eventEmitters) => {
    if (Array.isArray(eventEmitters)) {
        return eventEmitters.length
            ? eventEmitters.some((eventEmitter) => !!eventEmitter.observers.length)
            : false;
    }
    return eventEmitters.observers && !!eventEmitters.observers.length;
};

const describedByIds = (id, isMessage, inputAriaDescribed) => {
    let ariaDescribedId = id;
    if (inputAriaDescribed) {
        ariaDescribedId += ` ${inputAriaDescribed}`;
    }
    return isMessage ? ariaDescribedId : null;
};

const sortArrayOfObjects = (data, keyToSort, direction) => {
    if (direction === '') {
        return data;
    }
    const compare = (objectA, objectB) => {
        const valueA = objectA[keyToSort];
        const valueB = objectB[keyToSort];
        if (valueA === valueB) {
            return 0;
        }
        if (valueA > valueB) {
            return direction === 'asc' ? 1 : -1;
        }
        return direction === 'asc' ? -1 : 1;
    };
    return data.slice().sort(compare);
};

function getMonthList(locales = 'en', format = 'long') {
    const year = new Date().getFullYear();
    const monthList = [...Array(12).keys()];
    const formatter = new Intl.DateTimeFormat(locales, {
        month: format
    });
    const getMonthName = (monthIndex) => formatter.format(new Date(year, monthIndex));
    return monthList.map(getMonthName);
}

export { Translations, attrToBoolean, describedByIds, getMonthList, getUniqueID, hasObservers, instanceOfTest, isMobile, isTouchScreen, snakeToCamel, sortArrayOfObjects, toOrdinalNumber };

//# sourceMappingURL=aw-ads-components-src-utils.js.map